export const SelectedIcon = () => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_5637_14271)">
        <circle cx="11.5654" cy="7.50293" r="6.69434" fill="white" />
      </g>
      <path
        d="M8.23242 8.64031L10.0008 10.4095L14.8986 5.51172"
        stroke="#458FFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_5637_14271"
          x="0.871094"
          y="0.808594"
          width="21.3887"
          height="21.3887"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5637_14271" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5637_14271" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
